import { useEffect, useRef } from 'react'
import { useAuth } from '@clerk/clerk-react'
import { isCancelledError, useQueryClient } from '@tanstack/react-query'
import {
  refetchSettingsResolution,
  subscribeToSettingsResolutionChanges,
} from '../sync/settingsResolutionSync'
import { env } from '../../../config/env'

const hasClerkProvider = Boolean(env.VITE_CLERK_PUBLISHABLE_KEY)

export default function SettingsResolutionSyncController() {
  const { isLoaded, isSignedIn } = useAuth()
  const queryClient = useQueryClient()
  const enabled = hasClerkProvider ? isLoaded && Boolean(isSignedIn) : true
  const latestChangeRef = useRef(0)

  useEffect(() => {
    if (!enabled) return

    return subscribeToSettingsResolutionChanges((message) => {
      if (message.changedAt <= latestChangeRef.current) return
      latestChangeRef.current = message.changedAt
      refetchSettingsResolution(queryClient).catch((error) => {
        // A newer change cancelled this refetch and started its own.
        if (isCancelledError(error)) return
        if (import.meta.env.DEV) {
          console.error('Failed to sync settings resolution across tabs', error)
        }
      })
    })
  }, [enabled, queryClient])

  return null
}
